import Modal from "../common/Modal/Modal";
import Button from "../Button/Button";

const ALL_SIZES = ["P", "M", "G", "GG", "G1", "G2", "G3"];

interface EditProductSizesModalProps {
  isOpen: boolean;
  productName: string;
  selectedSizes: string[];
  isSaving: boolean;
  onToggle: (sz: string) => void;
  onSave: () => void;
  onClose: () => void;
}

const EditProductSizesModal = ({
  isOpen,
  productName,
  selectedSizes,
  isSaving,
  onToggle,
  onSave,
  onClose
}: EditProductSizesModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} maxWidth="max-w-[28rem]">
      <h2 className="text-base font-semibold mb-1 text-left">{productName}</h2>
      <p className="text-sm text-gray-500 mb-4">{"Selecione os tamanhos disponíveis:"}</p>
      <div className="flex flex-wrap gap-2 mb-3">
        {ALL_SIZES.map(sz => (
          <button
            key={sz}
            type="button"
            onClick={() => onToggle(sz)}
            className={`px-3 py-1 rounded border text-sm font-semibold transition-colors
              ${selectedSizes.includes(sz)
                ? "bg-primary-600 text-white border-primary-600"
                : "bg-white text-gray-600 border-gray-300 hover:border-primary-500"}`}
          >
            {sz}
          </button>
        ))}
      </div>
      <p className="text-xs text-gray-400 mb-5">{"Deixe todos marcados ou todos desmarcados para não restringir tamanhos (mostra P–G3)."}</p>
      <div className="flex gap-2">
        <Button variant="secondary"
          onClick={onClose}
          disabled={isSaving}
          className="flex-1 px-4 py-2 text-sm"
        >
          {"Cancelar"}
        </Button>
        <Button isLoading={isSaving}
          onClick={onSave}
          disabled={isSaving}
          className="flex-1 px-4 py-2 text-sm"
        >
          {"Salvar"}
        </Button>
      </div>
    </Modal>
  );
};

export default EditProductSizesModal;
